import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "@common/textInput";
import { RoleSelection } from "@common/roleSelection";
import { Props } from "./types";
import { Columns } from "./columns";
import styles from "./styles.scss";

function Form({ formData, usedRoles, edit }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.form}>
      <div className={styles.group}>
        <h2 className={styles.label}>
          {t("projectListingConfiguration.name")}
        </h2>
        <TextInput
          placeholder={t("projectListingConfiguration.name")}
          value={formData.name}
          input={(name) => edit({ ...formData, name })}
        />
      </div>
      <div className={styles.group}>
        <h2 className={styles.label}>
          {t("projectListingConfiguration.roles")}
        </h2>
        <div className={styles.roleSelection}>
          <RoleSelection
            selectedRoleIds={formData.roles}
            rolesToExclude={usedRoles}
            placeholder={t("projectListingConfiguration.roles")}
            select={(role) =>
              edit({
                ...formData,
                roles: [...formData.roles, role.name],
              })
            }
            unSelect={(role) =>
              edit({
                ...formData,
                roles: formData.roles.filter(
                  (id) => id !== role.uuid && id !== role.name,
                ),
              })
            }
          />
        </div>
      </div>
      <div className={styles.group}>
        <h2 className={styles.label}>
          {t("projectListingConfiguration.columns")}
        </h2>
        <Columns formData={formData} edit={edit} />
      </div>
    </div>
  );
}

export { Form };
